module.exports = __webpack_public_path__ + "static/media/yellow_stress_EN.91735ca1.png";